import { useState, useMemo } from 'react';

export default function useSortableData(items, initialConfig = { key: null, direction: 'ascending' }) {
  const [sortConfig, setSortConfig] = useState(initialConfig);

  const requestSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const sortedData = useMemo(() => {
    if (!sortConfig.key) return items;
    const sorted = [...(items || [])].sort((a, b) => {
      const aVal = a[sortConfig.key];
      const bVal = b[sortConfig.key];

      const aStr = aVal === null || aVal === undefined ? '' : aVal.toString();
      const bStr = bVal === null || bVal === undefined ? '' : bVal.toString();

      const aNum = parseFloat(aStr.replace(/[^0-9.\-]/g, ''));
      const bNum = parseFloat(bStr.replace(/[^0-9.\-]/g, ''));

      let cmp;
      if (!isNaN(aNum) && !isNaN(bNum)) {
        cmp = aNum - bNum;
      } else {
        cmp = aStr.toLowerCase().localeCompare(bStr.toLowerCase());
      }

      return sortConfig.direction === 'ascending' ? cmp : -cmp;
    });

    return sorted;
  }, [items, sortConfig]);

  return { sortedData, sortConfig, requestSort, setSortConfig };
}
